import React from "react";
import axios from "axios";
import { TextField, Typography, Autocomplete, debounce } from "@mui/material";
import * as settings from "../../settings";

export default function DistrictAutocomplete(props) {
  const handleInputChange = props.handleInputChange;
  const [districts, setDistricts] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");
  const [value, setValue] = React.useState(null);

  const fetch = React.useMemo(
    () =>
      debounce((request, callback) => {
        axios
          .get(
            `${settings.API_SERVER}/api/census/district_autocomplete/${request.input}/`
          )
          .then((res) => {
            setDistricts(res.data);
          })
          .catch((e) => {
            console.log("error getting districts", e);
            setDistricts([]);
          });
      }, 100),
    []
  );

  React.useEffect(() => {
    let active = true;

    if (inputValue === "") {
      setDistricts(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }
        setDistricts(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  return (
    <Autocomplete
      id="district"
      disablePortal
      autoComplete
      autoHighlight
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.label
      }
      noOptionsText="No matching districts found"
      filterOptions={(x) => x}
      options={districts}
      fullWidth
      value={value}
      onChange={(event, newValue) => {
        handleInputChange({ name: "district", value: newValue });
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" placeholder="District" />
      )}
      renderOption={(props, option) => {
        return (
          <li key={option.id} {...props}>
            <Typography>{option.label}</Typography>
            <Typography variant="body2" ml=".5em">
              {option.geoid}
            </Typography>
          </li>
        );
      }}
    />
  );
}
